module.exports = __webpack_public_path__ + "static/media/disco.e2cd991a.png";